/**
 * Prikaz roka koji može biti Date, ISO string ili srpski slobodan unos
 * "dd.MM.yyyy." (koji bi new Date() u Chrome-u pogrešno tumačio kao MM.dd).
 */
export function formatDeadline(deadline) {
  if (!deadline) return "—";

  const str = String(deadline).trim();
  // srpski format prikazujemo doslovno — bez rizika zamene dana i meseca
  if (/^\d{1,2}\.\d{1,2}\.\d{4}\.?$/.test(str)) return str;

  const d = new Date(str);
  return isNaN(d.getTime()) ? str : d.toLocaleDateString("sr-RS");
}
